import { apiSlice } from "../apiSlice";

export const couponMutationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Create coupon
    createCoupon: builder.mutation({
      query: (newCoupon) => ({
        url: "coupons",
        method: "POST",
        body: newCoupon,
      }),
      invalidatesTags: [{ type: "coupons", id: "LIST" }],
    }),

    // ✅ Update coupon
    updateCoupon: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `coupons/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "coupons", id },
        { type: "coupons", id: "LIST" },
      ],
    }),

    // ✅ Delete coupon
    deleteCoupon: builder.mutation({
      query: (id) => ({
        url: `coupons/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "coupons", id: "LIST" }],
    }),
  }),
});

export const {
  useCreateCouponMutation,
  useUpdateCouponMutation,
  useDeleteCouponMutation,
} = couponMutationApiSlice;
